import React from 'react'
import { Wrapper } from './styled'

export default function WaitFooter({ footerState }: any) {
    return (
        <Wrapper footerState={footerState === 'waitForNext'}>
            <section>
                <p>
                    WAIT FOR NEXT ROUND
                </p>
            </section>
        </Wrapper>
    )
}
